import { useCallback, useEffect, useRef, useState } from "react";
import { act } from "react-dom/test-utils";
import useEbsApiClient from "./useEbsApiClient.js";
import useTwitch from "./useTwitch.js";

export default function useFollowersLogic() {
  const ebsApiClient = useEbsApiClient();
  const { addPubSubEventListener, removePubSubEventListener } = useTwitch();
  const [followers, setFollowers] = useState([]);
  const [
    selectedFollowerForSelectionEvent,
    setSelectedFollowerForSelectionEvent,
  ] = useState(null);
  const [activeSelectionEvent, setActiveSelectionEvent] = useState(null);
  //const [activeSelectionEvent, setActiveSelectionEvent] = useState({
  //  reason: "DEMON",
  //  allowed_follower_ids: "*",
  //});

  const fetchFollowers = async () => {
    try {
      const { data: followers } = await ebsApiClient.get("/followers");
      setFollowers(followers);
    } catch (err) {
      // No follower found, silent fail
    }
  };

  const handleSelectionEventStart = async (data) => {
    setActiveSelectionEvent(data);
    setSelectedFollowerForSelectionEvent(null);
  };

  const handleSelectionEventEnd = () => {
    setActiveSelectionEvent(null);
    setSelectedFollowerForSelectionEvent(null);
  };

  const handleFollowersUpdate = () => {};

  const selectFollowerForSelectionEvent = async (follower) => {
    setSelectedFollowerForSelectionEvent(follower);

    try {
      await ebsApiClient.post("/followers/selection-event/vote", {
        follower_id: follower.type === "npc" ? follower.id : follower.viewer_id,
      });
    } catch (err) {
      setSelectedFollowerForSelectionEvent(null);
    }
  };

  useEffect(() => {
    fetchFollowers();
  }, []);

  useEffect(() => {
    (async () => {
      try {
        // TODO: get active selection event on load
        const { data: selectionEventData } = await ebsApiClient.get(
          "/followers/selection-event"
        );
        setActiveSelectionEvent(selectionEventData);
        if (selectionEventData.viewer_vote) {
          setSelectedFollowerForSelectionEvent(viewer_vote);
        }
      } catch (err) {
        // No follower selection event found, silent fail
      }
    })();
  }, []);

  useEffect(() => {
    addPubSubEventListener(
      "cotl.followerSelection.start",
      handleSelectionEventStart
    );
    addPubSubEventListener(
      "cotl.followerSelection.end",
      handleSelectionEventEnd
    );
    addPubSubEventListener("cotl.followers.update", fetchFollowers);

    return () => {
      removePubSubEventListener(
        "cotl.followerSelection.start",
        handleSelectionEventStart
      );
      removePubSubEventListener(
        "cotl.followerSelection.end",
        handleSelectionEventEnd
      );
      removePubSubEventListener("cotl.followers.update", fetchFollowers);
    };
  }, []);

  return {
    refetchFollowers: fetchFollowers,
    followers,
    activeSelectionEvent,
    selectedFollowerForSelectionEvent,
    selectFollowerForSelectionEvent,
  };
}
